/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as r from "react";
import { Button as m } from "@progress/kendo-react-buttons";
import { useLocalization as a } from "@progress/kendo-react-intl";
import { onDownPreventDefault as p } from "./utils.mjs";
import { messages as f } from "../messages/index.mjs";
import { selectAll as u } from "@progress/kendo-editor-common";
import { EditorToolsSettings as g } from "../config/toolsSettings.mjs";
const { selectAll: d } = g, C = (i) => {
  const { view: t, render: e, settings: o = d, ...n } = i, s = o.messages.title, c = r.useCallback(
    () => {
      t && (u(t.state, t.dispatch), t.focus());
    },
    [t]
  ), l = /* @__PURE__ */ r.createElement(
    m,
    {
      onClick: c,
      title: a().toLanguageString(s, f[s]),
      ...p,
      ...o.props,
      ...n
    }
  );
  return e ? e.call(void 0, l, { view: t }) : l;
};
export {
  C as SelectAll
};
